<script>
import ButtonControl from '../RangeSlider/ButtonControl.vue';
import RangeSlider from '../RangeSlider/RangeSlider.vue';
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch.vue';
import { mapGetters } from 'vuex';
export default {
  name: 'FormFilter',
  components: {
    ButtonControl,
    RangeSlider,
    ToggleSwitch,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    metricSliderList: {
      type: Array,
      required: true,
    },
    metricCheckboxList: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      id: null,
      label: null,
      activeField: null,
      activeMetric: null,
      activeSliderMetric: null,
      activeCheckboxMetric: null,
      activeRange: null,
      currentValue: 0,
    };
  },
  computed: {
    ...mapGetters({
      currentPreset: 'FormFinder/currentPreset',
    }),
    fieldCount: function() {
      return this.fields.length;
    },
    metricCount: function() {
      return this.metricSliderList.length;
    },
    metricCheckboxCount() {
      return this.metricCheckboxList.length;
    },
  },
  watch: {
    currentPreset: function() {
      this.setActiveField();
    },
  },
  mounted() {
    this.setActiveField();
  },
  methods: {
    // this component is a composite of multiple fields and metrics
    // so we need to map its data to the 'active' versions of each
    setActiveField: function() {
      if (!this.fields.length || (!this.metricSliderList.length && !this.metricCheckboxList.length)) return;

      this.activeField = this.fields[0];
      this.label = this.activeField.label;
      this.fields.forEach(field => {
        this.metricSliderList.forEach(metric => {
          if (field.metrics.includes(metric.id)) {
            if (metric.value > 0) {
              this.activeMetric = metric;
              this.currentValue = metric.value;
              this.activeRange = metric.range;
              this.id = metric.name;
            } else {
              if (metric.id.includes('winRate')) {
                this.activeMetric = metric;
                this.currentValue = metric.value;
                this.activeRange = metric.range;
                this.id = metric.name;
              }
            }
          }
        });
      });
    },
    subFieldChange: function([, name]) {
      this.fields.forEach((field, index) => {
        if (field.name === name) {
          this.activeField = index;
        }
      });
      this.change();
    },
    isActive: function(id) {
      return id === this.active;
    },
    change: function() {
      this.$emit('filterChange', this.activeField.id, this.activeMetric.id, this.currentValue, this.activeRange);
    },
    rangeChange: function([, value]) {
      this.currentValue = value;
      this.change();
    },
    fieldNames: function() {
      return this.fields.map(subField => ({
        label: subField.label,
        value: subField.name,
      }));
    },
    metricSliderNames: function() {
      return this.metricSliderList.map(metric => ({
        label: metric.displayName,
        value: metric.id,
      }));
    },
    metricSliderChange: function(newMetric) {
      this.metricSliderList.forEach(metric => {
        if (metric.id === newMetric) {
          this.activeMetric = metric;
        }
      });
      this.change();
    },
    metricCheckboxChange(checkboxId, value) {
      const checkboxValue = value ? 1 : 0;
      this.metricCheckboxList.forEach(metric => {
        if (metric.id === checkboxId && this.fields.length) {
          this.$emit('filterChange', this.fields[0].id, metric.id, checkboxValue, metric.range);
        }
      });
    },
  },
};
</script>
<template>
  <div v-if="metricCheckboxCount || activeMetric" class="form-finder__setting-wrap">
    <label :for="id">{{ label }}</label>
    <template v-if="metricCheckboxCount">
      <div
        v-for="(checkbox, index) in metricCheckboxList"
        :key="index"
        class="form-finder__setting-checkbox-item"
      >
        <div class="form-finder__setting-checkbox-text">{{ checkbox.displayName }}</div>
        <div class="form-finder__setting-checkbox-box">
          <input
            :name="checkbox.displayName"
            :id="`${checkbox.id}-${name}`"
            v-model="checkbox.value"
            type="checkbox"
            class="form-finder__setting-checkbox"
            @change="metricCheckboxChange(checkbox.id, checkbox.value)"
          >
          <label :for="`${checkbox.id}-${name}`"></label>
        </div>
      </div>
    </template>
    <template v-if="activeMetric">
      <div class="form-finder__slider-settings">
        <div class="form-finder__setting-label">
          <span class="range-slider__sub-label">
            Strike Rate:
            <b>{{ currentValue }}%</b>
          </span>
        </div>
        <div v-if="metricCount > 1" class="form-finder__setting-additional-element">
          <ButtonControl
            :buttons="metricSliderNames()"
            :active="activeMetric.id"
            name="button"
            @input="metricSliderChange"
          />
        </div>
      </div>
      
      <RangeSlider
        :min="activeMetric.minValue"
        :max="activeMetric.maxValue"
        :value="currentValue"
        :step="activeMetric.increments"
        :name="activeField.id"
        :label="name"
        @change="rangeChange"
      />
      <div class="form-finder__setting-additional">
        <div v-if="fieldCount > 1" class="form-finder__setting-additional-element">
          <ButtonControl
            :buttons="fieldNames()"
            :active="activeField.id"
            name="button"
            @input="subFieldChange"
          />
        </div>
      </div>
    </template>
  </div>
</template>
